import { commonErrorApiCodeExam } from "./errors-api-code-exam";
import { commonErrorApiCodeResourcesExam } from "./errors-api-code-resources-exam";

// Domain error-code dictionary, composed by the owning app transport.
// Assembled only from generated own namespaces, never from the monolithic catalog.
export const errorCodeDomain = {
  apiCodes: {
    ...commonErrorApiCodeExam,
  },
  apiCodeResources: {
    ...commonErrorApiCodeResourcesExam,
  },
  apiCodeReasons: {
  },
} as const;
